module.exports = __webpack_public_path__ + "9be7d40e2f99091070f18de2588c766d.png";